/* Confirmación de mayoría de edad (+18) en el carrito.
 * La casilla la pinta snippets/cart-age-check.liquid cuando el carrito
 * contiene algún producto con la etiqueta "bebida-alcoholica".
 * Mientras no esté marcada, se bloquea el botón de pago. */
(function () {
  const STORAGE_KEY = 'mm-carrito-mayor-de-edad';
  const INPUT_SELECTOR = '[data-cart-age-check-input]';
  const SCOPE_SELECTOR = 'cart-notification, cart-drawer, #main-cart-footer';
  const AGE_TOOLTIP_TEXT = 'Necesitas verificar tu edad';

  function isConfirmed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setConfirmed(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* noop */
    }
  }

  /* El carrito se vuelve a pintar por AJAX: recuperamos el estado de la casilla */
  function sync() {
    const inputs = document.querySelectorAll(INPUT_SELECTOR);
    const confirmed = isConfirmed();
    inputs.forEach((input) => {
      input.checked = confirmed;
    });
    document.body.classList.toggle('cart-age-pending', inputs.length > 0 && !confirmed);

    /* Deshabilita el botón de pago mientras la casilla esté visible y sin marcar */
    document.querySelectorAll(SCOPE_SELECTOR).forEach((scope) => {
      const pending = Boolean(scope.querySelector(INPUT_SELECTOR)) && !confirmed;
      scope.querySelectorAll('[name="checkout"]').forEach((button) => {
        if (pending && !button.disabled) {
          button.disabled = true;
          button.dataset.ageCheckLocked = 'true';
        } else if (!pending && button.dataset.ageCheckLocked) {
          button.disabled = false;
          delete button.dataset.ageCheckLocked;
        }
      });

      /* El aviso del botón de pago cambia de mensaje mientras falte la verificación */
      const tooltip = scope.querySelector('.checkout-button-tooltip');
      if (tooltip) {
        if (tooltip.dataset.defaultText === undefined) tooltip.dataset.defaultText = tooltip.textContent.trim();
        const text = pending ? AGE_TOOLTIP_TEXT : tooltip.dataset.defaultText;
        if (tooltip.textContent !== text) tooltip.textContent = text;
        tooltip.hidden = !text;
      }
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches(INPUT_SELECTOR)) return;
    setConfirmed(event.target.checked);
    sync();
    if (event.target.checked) {
      document.querySelectorAll('[data-cart-age-check-error]').forEach((error) => {
        error.hidden = true;
      });
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[name="checkout"]');
      if (!button) return;

      const scope = button.closest(SCOPE_SELECTOR);
      const input = scope && scope.querySelector(INPUT_SELECTOR);
      if (!input || input.checked) return;

      event.preventDefault();
      event.stopPropagation();
      const error = scope.querySelector('[data-cart-age-check-error]');
      if (error) error.hidden = false;
      input.focus();
    },
    true
  );

  function init() {
    sync();
    const observer = new MutationObserver(sync);
    document.querySelectorAll('#cart-notification-age-check, #main-cart-footer').forEach((container) => {
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
